import React from 'react'

interface RandomizerIconProps {
    className?: string
}

export const RandomizerIcon: React.FC<RandomizerIconProps> = ({ className }) => (
    <svg
        className={className}
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            x="3.5"
            y="3.5"
            width="17"
            height="17"
            rx="3"
            stroke="currentColor"
            strokeWidth="2"
        />
        <circle
            cx="8.5"
            cy="8.5"
            r="1.5"
            fill="currentColor"
        />
        <circle
            cx="12"
            cy="12"
            r="1.5"
            fill="currentColor"
        />
        <circle
            cx="15.5"
            cy="15.5"
            r="1.5"
            fill="currentColor"
        />
    </svg>
)
